import './PartnerDashboardView.scss';
import { constVoid } from 'fp-ts/function';
import { iframeResizer } from 'iframe-resizer';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CustomLoading } from 'src/modules/common/components/CustomLoading';

type Props = {
  readonly url: string;
};

export const PartnerDashboardView = ({ url }: Props): React.ReactElement => {
  const iframe = useRef<HTMLIFrameElement | null>(null);
  useEffect(() => {
    const frame = iframe.current;
    if (!frame) {
      return constVoid;
    }

    const frames = iframeResizer({
      minHeight: 500,
      autoResize: true,
    }, frame);

    return () => {
      frames.forEach((it) => it.iFrameResizer.removeListeners());
    };
  });

  const [ready, setReady] = useState(false);
  const handleLoad = useCallback(() => {
    setReady(true);
  }, []);

  return (
    <div className="bp-partner-dashboard-view">
      <div className="bp-partner-dashboard-view__content">
        <iframe
          ref={iframe}
          title="Dashboard"
          src={`${url}#theme=transparent&background=false&bordered=false&titled=false`}
          className="bp-partner-dashboard-view__iframe"
          onLoad={handleLoad}
        />

        {!ready && (
          <div className="bp-partner-dashboard-view__loader">
            <CustomLoading/>
          </div>
        )}
      </div>
    </div>
  );
};
